import { memo } from "react";

import { FeatureIslandContainer } from "@/components/features/_layouts";

import { ManagementRefundRequestTopHeader as Header } from "./header";
import { ManagementRefundRequestTopTable as Table } from "./table";
import { useInitialized } from "../../model/use-case";

type Props = {
	hotelID: string;
};

export const ManagementRefundRequestTop = memo(({ hotelID }: Props) => {
	const { data } = useInitialized({ hotelID });

	return (
		<FeatureIslandContainer>
			<Header />

			<Table refundRequestList={data?.refundRequestList.list ?? []} />
		</FeatureIslandContainer>
	);
});

ManagementRefundRequestTop.displayName = "ManagementRefundRequestTop";
